import { render, staticRenderFns } from "./RecordManage.vue?vue&type=template&id=d9629112&scoped=true"
import script from "./RecordManage.vue?vue&type=script&lang=js"
export * from "./RecordManage.vue?vue&type=script&lang=js"
import style0 from "./RecordManage.vue?vue&type=style&index=0&id=d9629112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9629112",
  null
  
)

export default component.exports